import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as Sort } from '../../assets/icons/sort.svg';
import { ReactComponent as SortBlack } from '../../assets/icons/sort-black.svg';
import { ReactComponent as SortBlue } from '../../assets/icons/sort-blue.svg';

const SortIcon = ({ dataIndex, tableParams }) => {
  const { theme } = useTheme();
  const getIconComponent = () => {
    if (
      tableParams?.sort?.[dataIndex] &&
      tableParams?.sort?.[dataIndex] !== ''
    ) {
      return SortBlue;
    }
    return theme === DARK ? Sort : SortBlack;
  };
  return <Icon component={getIconComponent()} style={{ fontSize: '24px' }} />;
};

SortIcon.propTypes = {
  dataIndex: PropTypes.string.isRequired,
  tableParams: PropTypes.object,
};

export default SortIcon;
